/**
 * This file is part of Magestore POS Open Source.
 *
 * Magestore POS Open Source is free software: you can redistribute it
 * and/or modify it under the terms of the GNU General Public License
 * as published by the Free Software Foundation, either version 3
 * of the License, or (at your option) any later version.
 *
 * Magestore POS Open Source is distributed in the hope that it will
 * be useful, but WITHOUT ANY WARRANTY; without even the implied warranty
 * of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along
 * with Magestore POS Open Source. If not, see <https://www.gnu.org/licenses/>
 */
import Config from '../config/Config'
import ConfigConstant from "../view/constant/ConfigConstant";

export default {
    // eslint-disable-next-line
    regexEmail: /^([a-z0-9,!\#\$%&'\*\+\/=\?\^_`\{\|\}~-]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z0-9,!\#\$%&'\*\+\/=\?\^_`\{\|\}~-]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*@([a-z0-9-]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z0-9-]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*\.(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]){2,})$/i,
    
    /**
     * Get config by path
     *
     * @param path
     * @returns {null}
     */
    getConfig(path) {
        let config = Config.config.settings.find(item => item.path === path);
        return config ? config.value : null;
    },

    /**
     * Sort array object by array condition fields
     *
     * @param arrayObject
     * @param arraySortFiels
     * @param dirrection
     * @return {*}
     */
    sortArrayObjectsByArrayFields(arrayObject, arraySortFiels, dirrection = 'ASC') {
        return arrayObject.sort((a, b) => this.sortByArrayFields(a, b, arraySortFiels, dirrection));
    },

    /**
     * Sort array object by array condition fields
     *
     * @param a
     * @param b
     * @param arraySortFiels
     * @param index
     * @param direction
     * @return {number}
     */
    sortByArrayFields(a, b, arraySortFiels, direction = 'ASC', index = 0) {
        if (a[arraySortFiels[index]] === b[arraySortFiels[index]]) {
            return this.sortByArrayFields(a, b, arraySortFiels, direction, index + 1);
        } else {
            if (a[arraySortFiels[index]] > b[arraySortFiels[index]]) {
                return direction === "ASC" ? 1 : -1;
            }
            return direction === "ASC" ? -1 : 1;
        }
    },

    isShowReasonOnReceipt() {
        let isEnable = this.getConfig('webpos/custom_receipt/display_reason');
        return !!(isEnable && isEnable === '1');
    },

    /**
     * get locale code
     * @returns {*|null}
     */
    getLocaleCode() {
        let localeCode = this.getConfig(ConfigConstant.CONFIG_XML_PATH_GENERAL_LOCALE_CODE);
        if (!localeCode)
            localeCode = "en_US";
        return localeCode
    },
    /**
     *  get version of magento
     * @returns {*|null}
     */
    getMagentoVersion() {
        return Config.config.magento_version;
    },
    /**
     *
     * @param version
     * @param operator
     * @returns {boolean}
     */
    compareMagentoVersion(version, operator) {
        operator = operator || '===';

        if (!version) {
            return false;
        }

        let magentoVersion = this.getMagentoVersion();

        if (!magentoVersion) {
            return false
        }

        let magentoVersionPath = magentoVersion.split('.');
        if (magentoVersionPath.length < 3) {
            return false;
        }
        let result = String(version).split('.').map((number, index) => {
            if (operator === '===') {
                return Number(magentoVersionPath[index]) === number;
            }
            if (operator === '>=') {
                return Number(magentoVersionPath[index]) >= number;
            }
            if (operator === '>') {
                return Number(magentoVersionPath[index]) > number;
            }
            if (operator === '<=') {
                return Number(magentoVersionPath[index]) <= number;
            }
            return Number(magentoVersionPath[index]) < number;
        });

        return result.reduce((current, next) => current && next, true);
    }
}



// WEBPACK FOOTER //
// ./src/helper/ConfigHelper.js